<template>
  <v-app>
    <dashboard-core-app-bar v-if="!$route.path.startsWith('/photo/upload')"/>

    <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" v-if="!$route.path.startsWith('/photo/upload')"/>

    <dashboard-core-view />
    <v-snackbar
      v-model="snackbar.show"
      top
      right
      vertical
      :timeout="5000"
    >
      {{ snackbar.text }}
      <v-btn
        color="pink"
        text
        @click="snackbar.show = false"
      >
        Закрыть
      </v-btn>
    </v-snackbar>
    <!--<dashboard-core-settings v-model="expandOnHover" />-->
  </v-app>
</template>

<script>
import { setTimeout, clearTimeout } from 'timers';
import { setInterval } from 'timers';
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      active: true,
      expandOnHover: false,
      snackbar: {
        text: '',
        show: false,
      },
    }),
    mounted: function() {
      let self = this
      window.onbeforeunload = function() {
        if (self.$route.path.indexOf('create') > -1 || self.$route.path.indexOf('change') > -1)
          return "Данные не сохранены. Точно перейти?";
          else return true
      };
      setInterval(function() {
        if (self.$route.path === '/pages/login' || self.$route.path === '/pages/recover' || self.$route.path.startsWith('/photo/upload')) {
          return
        }
         if (self.active) {
          self.active = false
          self.$axios.post('/api/auth/check/', {lock: self.$store.state.lock})
            .then(response => {
              if (!response.data.error) {
                // store.state.user = response.data.user
                self.$store.commit('user', response.data.user)
                if (response.data.token) localStorage.setItem('token', response.data.token)
                let obj = {}
                for (let x in response.data.dictionaries) {
                  let dict = response.data.dictionaries[x]
                  let data = {}
                  for (let y in dict.data) {
                    if (dict.data[y].enabled) {
                      data[dict.data[y].value] = dict.data[y].data
                    }
                  }
                  obj[dict.name] = data
                }
                obj['log'] = {
                  1: 'Создание клиента',
                  2: 'Изменение клиента',
                  3: 'Создание события',
                  4: 'Изменение события',
                  5: 'Создание договора',
                  6: 'Изменение договора',
                  7: 'Создание пользователя',
                  8: 'Изменение пользователя',
                  9: 'Регистрация пользователя',
                  10: 'Создание словаря',
                  11: 'Изменение словаря',
                  12: 'Авторизация пользователя',
                  13: 'Создание настроек',
                  14: 'Изменение настроек',
                },
                self.$store.commit('settings', response.data.settings)
                self.$store.commit('dictionary', obj)
              } else {
                self.$router.push('/pages/login')
            }
          })
          .catch(e => {
            self.$router.push('/pages/login')
          })
        }
      }, 60000)
      document.onmousemove = activeUser; 
      function activeUser() {
        self.active = true
      }
    },
    watch: {
      '$store.state.snackbar.show': function () {
        this.snackbar = this.$store.state.snackbar
      },
    },
  }
</script>
